/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetPLForUserByAccountOptions,
  GetPLForUserByAccountResponses,
} from '../types/GetPLForUserByAccount'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get account-by-account PL breakdown for a user
 * {@link /v1/pl/:user_id}
 */
export function getPLForUserByAccount<ThrowOnError extends boolean = true>(
  options: Options<GetPLForUserByAccountOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetPLForUserByAccountResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/pl/{user_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetPLForUserByAccountResponses, ThrowOnError>>,
  )
}
